/**
 * ユーザー権限
 */
export const History = {
  // ログイン
  ログイン: 1,
  // ログアウト
  ログアウト: 2,
  // ステータス変更
  ステータス変更: 3,
} as const;

export type HistoryType = typeof History[keyof typeof History];
